import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  padding: (p) => p.spacing(2),
  gap: (p) => p.spacing(0.5),
};
